import {
  Box,
  useMediaQuery,
  Typography,
  Slide,
} from '@mui/material';
import {
  ArrowBack,
  Menu as MenuIcon,
} from '@mui/icons-material';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import Header from '../v2/TopNav/Header';
import Sidebar from '../v3/Sidebar';
import { useEffect, useState } from 'react';
import { decodeToken } from '../utils/settings';
import BottomTabBar from '../v3/BottomTabs';
import { getTabConfig } from '../v3/BottomTabs/tabConfig';
import { useSelector } from 'react-redux';

const HomeLayout = ({
  children,
  sidebarTitle = null,
  isPwa = false,
  backroute = null,
  moduleKey = null,
  isHomePage = false,
  showMenu
}) => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const isMobile = useMediaQuery('(max-width: 1200px)');
  const navigationTarget = backroute ? backroute : -1;
  const [open, setOpen] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  
  const toggleDrawer = () => {
    setOpen(!open);
  };
  useEffect(() => {
    const getTokenData = async () => {
      if (token) {
        try {
          const decoded = await decodeToken(token);
          setTokenData(decoded);
        } catch (err) {
          console.error('Failed to decode token', err);
        }
      }
    };
    getTokenData();
  }, [token]);
  
  const allowedKeys = tokenData?.menu_config ?? [];
  const isAllowed = (key) => {
    if (!allowedKeys || allowedKeys.length === 0) return true;
    return allowedKeys.includes(key);
  };
  const tabConfig = getTabConfig(isPwa);
  const TabConfig = tabConfig.filter(
    (tab) => isAllowed(tab.key) || tab.visible
  );
  
  const { loginUser } = useSelector((state) => ({
    loginUser: state.loginReducer.loginUser,
  }));
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center'}}>
      <Box
        sx={{
          width: '100%',
          maxWidth: '1920px',
          position: 'relative',
        }}
      >
        <Box
            sx={{
                position: 'absolute',
                width: {xs:'650px' , md: '686.31px'},
                height: { xs:'-webkit-fill-available',md: '900.23px', xl: '-webkit-fill-available' },
                display: 'block',
                top: '-210.68px',
                left: '-315.54px',
                borderRadius: '4px',
                transform: 'rotate(0deg)',
                backgroundImage: `url('https://d2djimvzddgguw.cloudfront.net/humbee-homepage-images/banner/hexagon-pattern.svg')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}
        /> 
        <Box sx={{ 
          position: 'sticky',
          top: 0,
          zIndex: 1300,
          pb: { xs: 0, md: 2 },
          pt: { xs: 2 },
          px: { xs: 2 },
          backgroundColor: '#FAFAFA'
        }}>
          <Header 
            isHomePage={isHomePage}
            sidebarTitle={sidebarTitle} 
            backroute={backroute} 
            toggleDrawer={toggleDrawer}
            isPwa={isPwa}
            showMenu={showMenu}
          />
        </Box>
        
        <Box 
          sx={{ 
            display: { md: 'flex'}, 
            height: {xs: 'auto', md: 'calc(100vh - 130px)'}, 
            overflow: 'hidden',
            mt: { xs: 0, md: 0 }
          }}
        >
            {isMobile && open && (
              <>
                <Slide direction="left" in={open} mountOnEnter unmountOnExit timeout={{ enter: 500, exit: 300 }}>
                  <Box sx={{ 
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'fixed',
                    zIndex: 2000,
                    top: 0,
                    right: '-130px',
                    transition: 'right 0.3s ease',
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                  }}>
                      <Sidebar 
                        moduleKey={moduleKey} 
                        showFullMenu={false} 
                        onMenuItemClick={() => {
                          setOpen(false);
                        }}
                        mobile={true}
                        backroute={backroute} 
                        isHomePage={isHomePage}
                      />
                  </Box>
                </Slide>
              </>
            )}            
            {!isMobile && (loginUser || isPwa) &&  (
              <Box
                sx={{
                  width: 300,
                  minWidth: 300,
                  height: '100%',
                  position: 'relative',
                  zIndex: 1050,
                  flexShrink: 0,
                  overflowX: 'auto',
                  ml: 2
                }}
              >
                <Sidebar 
                  showFullMenu={true} 
                  moduleKey={moduleKey} 
                  backroute={backroute} 
                  isHomePage={isHomePage}
                  onMenuItemClick={() => {
                    setOpen(false);
                  }}
                  mobile={false}
                />
              </Box>
            )}
            <Box    
              sx={{
                flexGrow: 1,
                height: '100%',
                overflowY: open ? 'hidden' : 'auto',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {!isMobile && sidebarTitle && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    pb: 2,
                    px: 2,
                  }}
                >
                  <ArrowBack
                    onClick={() => navigate(navigationTarget)}
                    fontSize="medium"
                    sx={{ cursor: 'pointer' }}
                  />
                  <Typography
                    variant="h1"
                    sx={{ ml: 2 }}
                  >
                    {sidebarTitle}
                  </Typography>
                </Box>
              )}
              <Box sx={{ flexGrow: 1, overflow: open && 'hidden', marginBottom: '70px' }}>{children}</Box>
              
              {isMobile && (loginUser || isPwa) && TabConfig.length > 0 && (
                <BottomTabBar tabConfig={TabConfig} />
              )}
            </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HomeLayout;
